import React from 'react';
import { SubsessionClient } from '../index-types';
export default React.createContext<SubsessionClient | null>(null);
